/**
 * Copyright 2024 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

import { useRef, useState, useEffect } from "react";
import "./Teacher.scss";
import { LiveAPIProvider } from "../contexts/LiveAPIContext";
//import SidePanel from "./components/side-panel/SidePanel";
import { Altair } from "../components/altair/Altair";
import ControlTray from "../components/control-tray/ControlTray";
import cn from "classnames";
import { LiveClientOptions } from "../types";

// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
//import { getAnalytics } from "firebase/analytics";
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
  apiKey: "AIzaSyBXpRiBwR3epct6zzU04ASL9q9OyvQsuWY",
  authDomain: "guandoloo.firebaseapp.com",
  databaseURL: "https://guandoloo.firebaseio.com",
  projectId: "guandoloo",
  storageBucket: "guandoloo.firebasestorage.app",
  messagingSenderId: "319186668070",
  appId: "1:319186668070:web:b52b27b24d5bc2652134e7",
  measurementId: "G-DGZ5HJMBJB"
};

// Initialize Firebase
initializeApp(firebaseConfig);
//const analytics = getAnalytics(app);

const API_KEY = process.env.REACT_APP_GEMINI_API_KEY as string;
if (typeof API_KEY !== "string") {
  throw new Error("set REACT_APP_GEMINI_API_KEY in .env");
}

const apiOptions: LiveClientOptions = {
  apiKey: API_KEY,
};

function Teacher() {
  // this video reference is used for displaying the active stream, whether that is the webcam or screen capture
  // feel free to style as you see fit
  const videoRef = useRef<HTMLVideoElement>(null);
  // either the screen capture, the video or null, if null we hide it
  const [videoStream, setVideoStream] = useState<MediaStream | null>(null);
  const [showAnimation, setShowAnimation] = useState(true);

  useEffect(() => {
    // Auto-hide animation after 5 seconds
    const timer = setTimeout(() => {
      setShowAnimation(false);
    }, 5000);

    return () => clearTimeout(timer);
  }, []);

  return (
    <div className="App">
      <LiveAPIProvider options={apiOptions}>
        <div className="streaming-console">
          {/* <SidePanel /> */}
          <main>
            <div>
              <br></br>
              <br></br>
            </div>
            <div className="main-app-area">

              {/*<div className="frisoles-link-container">
                <a href="https://musilove.web.app" target="_blank" rel="noopener noreferrer" className="frisoles-link">
                  musilove
                </a> 
              </div>*/}

              {/* APP goes here */}
              <Altair />
              <video
                className={cn("stream", {
                  hidden: !videoRef.current || !videoStream,
                })}
                ref={videoRef}
                autoPlay
                playsInline
              />

              {/* Animated tutorial overlay */}
              {showAnimation && (
                <div className="talk-animation-overlay">
                  <div className="talk-animation-container">
                    <div className="talk-animation-content">
                      <h2 className="talk-animation-title">Welcome to AI!</h2>
                      <p className="talk-animation-text">
                        Click the <span className="play-button-highlight">play button</span> here to start talking to the AI teacher
                      </p>
                      <div className="talk-animation-arrow">
                        <svg width="40" height="60" viewBox="0 0 40 60" fill="none">
                          <path d="M20 60 L20 20 M20 20 L10 30 M20 20 L30 30" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                        </svg>
                      </div>
                    </div>
                    <button
                      className="talk-animation-dismiss"
                      onClick={() => setShowAnimation(false)}
                    >
                      Got it!
                    </button>
                  </div>
                </div>
              )}
            </div>


            <ControlTray
              videoRef={videoRef}
              supportsVideo={true}
              onVideoStreamChange={setVideoStream}
              enableEditingSettings={true}
            >
              {/* put your own buttons here */}
            </ControlTray>
          </main>
        </div>
      </LiveAPIProvider>
    </div>
  );
}

export default Teacher;
